var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--login"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--xl"
  }, [_vm._v(_vm._s(_vm.$t('common.로그인')))])]), _c('v-card', {
    staticClass: "ma-auto",
    attrs: {
      "max-width": "550"
    }
  }, [_c('div', {
    staticClass: "pa-30 px-lg-50 pt-lg-70 pb-lg-60"
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('u-text-field', {
    attrs: {
      "placeholder": "아이디",
      "type": "text"
    },
    model: {
      value: _vm.username,
      callback: function ($$v) {
        _vm.username = $$v;
      },
      expression: "username"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('u-text-field', {
    attrs: {
      "placeholder": "비밀번호",
      "type": "password"
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.login.apply(null, arguments);
      }
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": true,
      "label": _vm.$t('common.아이디 저장'),
      "hide-details": ""
    },
    model: {
      value: _vm.remember,
      callback: function ($$v) {
        _vm.remember = $$v;
      },
      expression: "remember"
    }
  })], 1)], 1), _c('div', {
    staticClass: "mt-20 mt-md-30"
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t('common.로그인')))])], 1), _c('div', {
    staticClass: "mt-16 mt-md-20"
  }, [_c('v-row', {
    staticClass: "row--small font-size-16 font-size-md-18 font-size-lg-20 font-weight-medium grey-4e--text",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/join?code=PERSON"
    }
  }, [_vm._v("회원가입")])], 1), _c('v-col', {
    staticClass: "d-inline-flex align-center",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "h-12px",
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/login/find-id"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.아이디 찾기')))])], 1), _c('v-col', {
    staticClass: "d-inline-flex align-center",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "h-12px",
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/login/find-password"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.비밀번호 찾기')))])], 1)], 1)], 1)], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }